export type DiscountItem = {
	NAME: string
	CODE: string | null
	SORT: number
	SORT_IN_CATALOG: number | null
	SHORT_NAME: string
	BACKGROUND_COLOR: string
	HIDE_ON_LIST: boolean | null
	TEXT_COLOR: string | null
	ID: number
	CUSTOM_LINK: string | null
	ACTIVE_FROM: string | null
	ACTIVE_TO: string | null
}

export const discountAdapter = (item: any): DiscountItem[] => {
	const discounts: DiscountItem[] = []
	let discountId = 1 // Начальный ID для акций, можно увеличивать для разных акций

	// Если указан новый аккумулятор, создаем акцию
	if (item.IS_NEW_BATTERY) {
		discounts.push({
			NAME: 'Акция с новым аккумулятором',
			CODE: null, // Ссылка отсутствует
			SORT: 1, // Приоритет отображения
			SORT_IN_CATALOG: null,
			SHORT_NAME: 'Новый аккумулятор', // Короткое имя для акции
			BACKGROUND_COLOR: '#4CAF50', // Цвет для лейбла
			HIDE_ON_LIST: null,
			TEXT_COLOR: null,
			ID: discountId++, // Идентификатор акции
			CUSTOM_LINK: null, // Ссылка отсутствует
			ACTIVE_FROM: null,
			ACTIVE_TO: null
		})
	}

	// Если указан тег акции, создаем вторую акцию
	if (item.PROMOTION_TAG) {
		discounts.push({
			NAME: 'Промоакция', // Название акции
			CODE: item.PROMOTION_DESCRIPTION || null, // Если есть ссылка
			SORT: 2, // Приоритет отображения
			SORT_IN_CATALOG: null,
			SHORT_NAME: item.PROMOTION_TAG, // Короткое имя для акции (тег)
			BACKGROUND_COLOR: '#FF8945', // Цвет для лейбла
			HIDE_ON_LIST: null,
			TEXT_COLOR: null,
			ID: discountId++, // Идентификатор акции
			CUSTOM_LINK: item.PROMOTION_DESCRIPTION || null, // Ссылка, если она есть
			ACTIVE_FROM: null,
			ACTIVE_TO: null
		})
	}

	return discounts
}
